import type { FC } from "react";
import { useAgents } from "../../admin/agents/useAgents";
import MultiSelect from "../../components/select/MultiSelect";

interface Props {
  readonly agentIds: string[];
  readonly defaultAgentId?: string;
  readonly label?: string;
  readonly readonly?: boolean;
  readonly onChange: (agentIds: string[]) => void;
}

const AgentMultiSelect: FC<Props> = ({ agentIds, defaultAgentId, label, readonly, onChange }) => {
  const { agents } = useAgents();
  return (
    <MultiSelect
      label={label ?? "Opiekun"}
      fullWidth
      selected={agentIds}
      readonly={readonly}
      values={
        agents?.map((a) => ({
          value: a.id,
          label: defaultAgentId && a.id === defaultAgentId ? `${a.name} (domyślny)` : a.name,
        })) ?? []
      }
      onSelect={(agentId) => onChange(agentId)}
    />
  );
};

export default AgentMultiSelect;
